const getFilters = (state) => state.research.filters;

export default {
  getIsFilterFetching: (state) => getFilters(state).isFetching,
  getFilterItems: (state) => getFilters(state).items,
  getInitialFilter: (state) => getFilters(state).initialFilters,
  getAppliedFilter: (state) => getFilters(state).appliedFilters,
  getFiltersPayload: (state) => getFilters(state).filtersPayload,
  getDateRankFilters: (state) => ({
    dateFromMin: getFilters(state).dateFromMin,
    dateToMax: getFilters(state).dateToMax,
  }),
};
